/**
 * @module experience/credit-check
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { ObjectInterface } from '@support/api/common/api-response.interface';

export class IdentificationDetails {
  /**
   * Stores the Document Id of the customer
   */
  public idNumber: string;

  /**
   * Stores the Document Type of the customer
   */
  public idType: string;
  /**
   * Stores the issuing State of the customer
   */
  public countryState: string;
  public birthDate: string;
  public SSN: string;

  constructor(identificationFormValue: ObjectInterface, birthDate: string) {
    this.idNumber = identificationFormValue.idNumber;
    this.idType = identificationFormValue.idType;
    this.birthDate = birthDate;
    // @TODO defaulting to USA as API was failing if we pass state code in request
    // this.countryState = identificationFormValue.city;
    this.countryState = 'USA';
    this.SSN = identificationFormValue.ssn;
  }
}
